module.exports = __webpack_public_path__ + "static/img/fuwu-haiyang.76398f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/fuwu-haiyang.jpg
// module id = 8wZ0
// module chunks = 1